import { cn } from 'src/lib/utils';

type Props = {
  label: string;
  value: string | null | undefined;
};

const STATUS_COLOURS: Record<string, string> = {
  running: 'bg-blue-100 text-blue-800 border-blue-200',
  idle: 'bg-gray-100 text-gray-800 border-gray-200',
  failed: 'bg-red-100 text-red-800 border-red-200',
  loaded: 'bg-green-100 text-green-800 border-green-200',
  missing: 'bg-amber-100 text-amber-900 border-amber-200',
  partial: 'bg-yellow-100 text-yellow-900 border-yellow-200',
  error: 'bg-red-100 text-red-800 border-red-200',
};

export function EtlStatusBadge({ label, value }: Props) {
  const normalized = (value ?? 'unknown').toLowerCase();
  const colourClass = STATUS_COLOURS[normalized] ?? 'bg-gray-100 text-gray-800 border-gray-200';

  return (
    <div className="flex flex-col gap-1">
      <span className="text-xs font-medium text-gray-600">{label}</span>
      <span
        className={cn(
          'inline-flex w-fit items-center rounded-full border px-3 py-1 text-sm font-semibold capitalize',
          colourClass,
        )}
      >
        {value ?? 'Unknown'}
      </span>
    </div>
  );
}
